import { useState } from 'react';

export default function TopAdBanner() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="w-full bg-gradient-to-r from-[#c8dff0]/60 via-[#ddeaf5]/80 to-[#c8dff0]/60 backdrop-blur-sm border-b border-[#b8d4ea]/50 py-2 px-4 flex items-center justify-center relative">
      <div className="flex items-center gap-3">
        <span className="text-[10px] font-semibold text-[#0088CC] bg-[#0088CC]/10 border border-[#0088CC]/20 px-2 py-0.5 rounded-full uppercase tracking-wider">Ad</span>
        <p className="text-xs text-slate-500">
          <span className="text-slate-700 font-semibold">TeleBoost Pro</span> — Grow your Telegram community 10x faster with AI-powered promotion.
          <a href="#" className="text-[#0088CC] ml-2 font-semibold hover:underline">Learn More &rarr;</a>
        </p>
      </div>
      <button
        onClick={() => setVisible(false)}
        className="absolute right-4 text-slate-400 hover:text-slate-600 cursor-pointer transition-colors"
        aria-label="Close banner"
      >
        <i className="ri-close-line text-sm"></i>
      </button>
    </div>
  );
}
